import { SafePlugin } from '@atlaskit/editor-common/safe-plugin';
import type { EditorView } from '@atlaskit/editor-prosemirror/view';

/**
 * A lightweight PM plugin that captures a reference to the editor view on init
 * and clears it on destroy.
 *
 * Kept as a separate plugin to avoid bloating the main malleableUi PM plugin
 * with concerns unrelated to its core state management.
 */
export function createEditorViewCapturePlugin(
	onEditorViewInit: (view: EditorView) => void,
	onEditorViewDestroy?: () => void,
): SafePlugin {
	return new SafePlugin({
		view(editorView) {
			onEditorViewInit(editorView);
			return {
				destroy() {
					onEditorViewDestroy?.();
				},
			};
		},
	});
}
